import { Opaque } from "../../Engine/src/Helpers/TypingUtils";

export interface NidusEntryData {
    [key: string]: string;
}

export interface NidusEntry {
    id: NidusEntryId;
    data: NidusEntryData;
}

export type NidusReferenceKey = string | null | undefined;

export type NidusName = string;

export type NidusEntryId = Opaque<string, "NidusEntryId">;

export function parseEntryId(input: string): NidusEntryId {
    return input as NidusEntryId;
}

export function emptyNidusEntryId(): NidusEntryId {
    return "" as NidusEntryId;
}

export interface NidusSearchResponse {
    items: NidusEntry[];
    totalSuitableCount: number;
}

export interface INidusClient {
    search(
        nidusName: NidusName,
        key: NidusReferenceKey,
        searchValue: string | null | undefined
    ): Promise<NidusSearchResponse>;
    searchMinitour(
        nidusName: NidusName,
        key: NidusReferenceKey,
        searchValue: string | null | undefined
    ): Promise<NidusSearchResponse>;
    insert(nidusName: NidusName, key: NidusReferenceKey, obj: NidusEntryData): Promise<NidusEntry>;
    delete(nidusName: NidusName, key: NidusReferenceKey, objectId: NidusEntryId): Promise<void>;
    update(nidusName: NidusName, key: NidusReferenceKey, objectId: NidusEntryId, obj: NidusEntryData): Promise<void>;
    batchInsert(nidusName: NidusName, key: NidusReferenceKey, objects: NidusEntry[]): Promise<void>;
}
